import Slider from 'react-slick'
import Link from 'src/components/ui/Link'

import type { ShopServiceDesktopProps } from './shop-services'
import './shopServices.scss'

const ShopServiceDesktop = ({ sources }: ShopServiceDesktopProps) => {
  const settings = {
    arrows: true,
    className: 'release-shelf',
    initialSlide: 0,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          arrows: true,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
        },
      },
    ],
  }

  return (
    <div className="page-services-container-source">
      <Slider {...settings} className="page-services-container-source">
        {sources.map((source, index) => (
          <div
            key={index}
            className="page-services-container-source-image-container"
          >
            <Link as="a" href={source.href}>
              <img
                className="page-services-container-source-image-container__img"
                src={source.srcSet}
                alt={source.alt}
                loading="lazy"
              />
              <p className="page-services-container-source-image-container__text">
                {source.text}
              </p>
            </Link>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default ShopServiceDesktop
